
(() => {
"use strict";
	function initStoreSlider() {

		new Splide('.store-slider__splide', {
			type: 'slide',
			rewind: true,
			autoplay: false,
			drag: true,
			snap: false,
			focus: 0,
			perPage: 1,
			autoWidth: true,
			pagination: false,
			arrows: false,
			gap: '16px',
			trimSpace: true,
			mediaQuery: 'min',
			breakpoints: {
				768: {
					destroy: true,
				},
			},
		}).mount();
	}

	document.addEventListener('DOMContentLoaded', initStoreSlider);
	document.addEventListener('shopify:section:load', initStoreSlider);

})();
